import { BusinessImpact, ProviderDataClassification, ProviderLifecycleStatus, RiskLevel } from '@kfolks/types'
import { z } from 'zod'

/**
 * Schema for creating a provider (HTTP POST body).
 */
export const providerCreateSchema = z.object({
	name: z.string().min(1),
	code: z.string().min(1),
	description: z.string().optional(),
	logoUrl: z.url().optional(),
	isActive: z.boolean().default(true),
	ownerId: z.uuid().optional(),
	lifecycleStatus: z.enum(ProviderLifecycleStatus).default(ProviderLifecycleStatus.ACTIVE),
	dataClassification: z.array(z.enum(ProviderDataClassification)).optional(),
	businessImpact: z.enum(BusinessImpact).default(BusinessImpact.NON_CRITICAL),
	riskLevel: z.enum(RiskLevel).default(RiskLevel.LOW),
	metadata: z.record(z.string(), z.unknown()).optional(),
})

/**
 * Schema for updating a provider (HTTP PUT body).
 */
export const providerUpdateSchema = providerCreateSchema.partial()

export type ProviderCreateInput = z.infer<typeof providerCreateSchema>
export type ProviderUpdateInput = z.infer<typeof providerUpdateSchema>
